module.exports = {
  DEFAULT_PROJECTION: 'mercator',
  DEFAULT_STYLE: 'Streets',
  DEFAULT_DARK_FEATURE_COLOR: '#555',
  DEFAULT_LIGHT_FEATURE_COLOR: '#e8e8e8',
  DEFAULT_SATELLITE_FEATURE_COLOR: '#00f900'
};
